<template>
  <div class="user-container">
    <el-tooltip class="item" effect="dark" :content="isFullscreen?'退出全屏':'全屏展示'" placement="bottom">
      <font-awesome-icon :icon="isFullscreen?'arrows-alt':'expand-arrows-alt'" @click="click" />
    </el-tooltip>
    <el-button type="text" @click="logout" style="color: #f56c6c;">退出</el-button>
  </div>
</template>

<script>
import screenfull from 'screenfull'
export default {
	name: 'User',
	data() {
		return {
			isFullscreen: screenfull.isFullscreen,
		}
	},
	mounted() {
		window.onresize = () => {
			this.isFullscreen = screenfull.isFullscreen
		}
	},
	methods: {
		click() {
			if (!screenfull.isEnabled) {
				return this.$message.warning('你的浏览器不支持全屏')
			}
			screenfull.toggle()
		},
		logout() {
			this.$confirm('此操作将登出当前账号, 是否继续?', '退出登录', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				try {
					localStorage.removeItem('x-auth-token')
					localStorage.removeItem('tenantlist')
					localStorage.removeItem('tenantId')
					localStorage.removeItem('tenantinfo')
					localStorage.removeItem('tenanuserlist')
					localStorage.removeItem('userinfo')
					localStorage.removeItem('tenantuserinfo')
					localStorage.removeItem('branchlist')
					localStorage.removeItem('mployeelist')
					localStorage.removeItem('savebranch')
					localStorage.removeItem('timeStamp')
					this.$message.success('登出成功')
				} catch (error) {
				} finally {
					this.$router.replace({ name: 'Login' })
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.user-container {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	margin-right: 10px;
}
</style>
